/**
 * Created by noOne on 29/08/2017.
 */

//--note zero is non wall, so start counting from 1, not zero--//
const wallTex = [
    "fence",//1:
    "house_wall",// 2:
    "house_door"//  3:
];

//--sliced up textures class--//
export default class Textures {
    constructor() {
        /**
         * @type {null}
         * @private
         */
        this._wallTextures = [];

        /**
         * @type {null}
         * @private
         */
        this._floorTextures = null;

        this.init();
    }

    init() {
        /*
         const wallTile = Common.assets.texture("wall");
         const floorTile = Common.assets.texture("texture");
         const texWid = wallTile.width, texHei = wallTile.height; //note texture height and width are the same, although it can help to use separate variables for clarity
         const textureArr = Common.matrix(1, texWid);
         Common.textureSize = texWid;
         const floorArr = Common.array(texHei); //only going to use one floor texture so 1d array is fine here

         for (let x = 0; x < texWid; x++) {
         textureArr[0][x] = new PIXI.Texture(wallTile, new PIXI.Rectangle(x, 0, 1, texHei));
         }
         this._wallTextures = textureArr;

         for (let y = 0; y < texWid; y++) {
         floorArr[y] = new PIXI.Texture(floorTile, new PIXI.Rectangle(0, y, texHei, 1))
         }
         this._floorTextures = Common.floorTextures = floorArr;
         */

        const texWid = Common.textureSize = 256;
        const texHei = 256;

        const len = wallTex.length;
        //--do wall textures--//
        for (let i = 0; i < len; i++) {
            const texTile = Common.assets.texture(wallTex[i]);
            const texArr = Common.array(texWid);
            for (let x = 0; x < texWid; x++) {
                texArr[x] = new PIXI.Texture(texTile, new PIXI.Rectangle(x, 0, 1, texHei));
            }
            this._wallTextures.push(texArr);
        }
        return;
        const floorTile = Common.assets.texture("texture");
        const floorArr = Common.array(texHei);

        for (let y = 0; y < texWid; y++) {
            floorArr[y] = new PIXI.Texture(floorTile, new PIXI.Rectangle(0, y, texHei, 1))
        }
        this._floorTextures = Common.floorTextures = floorArr;
    }

    /**
     * @returns {Array<PIXI.Texture>|null}
     */
    get wallTextures() {
        return this._wallTextures;
    }

    /**
     * @returns {Array<PIXI.Texture>|null}
     */
    get floorTextures() {
        return this._floorTextures;
    }
}